import ClientInfoView from './ClientInfoView';

export default ClientInfoView;
